import { createSlice } from '@reduxjs/toolkit';
import { GooglePayStore } from '../../types/StoreState';
import { isAction } from '../asyncMatchers';
import { getGooglePayOptions } from '../../actions/googlePay/getGooglePayOptions';

const initialState: GooglePayStore['options'] = {
  data: {},
  loading: 'idle' as const,
};

const googlePayOptionsSlice = createSlice({
  name: 'googlePay',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getGooglePayOptions.fulfilled, (state, action) => {
      state.data = action.payload;
    });
    builder.addMatcher(isAction(getGooglePayOptions), (state, action) => {
      state.loading = action.meta.requestStatus;
    });
  },
});

export const googlePayOptionsReducer = googlePayOptionsSlice.reducer;
